import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { fetchAPI } from "../utils/fetchAPI";

interface QrCode {
  qrCode: string;
  entityId: number;
  entityType: number;
  entityName: string;
  grade?: string;
  thickness?: string;
}

interface EditQrFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: QrCode) => void;
  qrCode: QrCode | null;
}

const EditQrForm: React.FC<EditQrFormProps> = ({ open, onClose, onSubmit, qrCode }) => {
  const [qrCodeValue, setQrCodeValue] = useState("");
  const [entityId, setEntityId] = useState("");
  const [entityType, setEntityType] = useState("");
  const [grade, setGrade] = useState("");
  const [thickness, setThickness] = useState("");
  const [steelItems, setSteelItems] = useState<any[]>([]);

  useEffect(() => {
    const fetchSteelItems = async () => {
      try {
        const data = await fetchAPI("GET", "steel.php");
        if (data?.success) {
          setSteelItems(data.data);
        }
      } catch (error) {
        console.error("Error fetching steel items:", error);
      }
    };

    fetchSteelItems();
  }, []);

  useEffect(() => {
    if (qrCode) {
      setQrCodeValue(qrCode.qrCode);
      setEntityId(qrCode.entityId?.toString() || "");
      setEntityType(qrCode.entityType.toString());
      setGrade(qrCode.grade || "");
      setThickness(qrCode.thickness || "");
    }
  }, [qrCode]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (qrCode) {
      onSubmit({
        ...qrCode,
        qrCode: qrCodeValue,
        entityId: entityType === "3" ? 0 : parseInt(entityId),
        entityType: parseInt(entityType),
        grade: entityType === "3" ? grade : undefined,
        thickness: entityType === "3" ? thickness : undefined,
      });
    }
  };

  return (
    <Modal show={open} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit QR Code</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>QR Code</Form.Label>
            <Form.Control
              type="text"
              value={qrCodeValue}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setQrCodeValue(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Entity Type</Form.Label>
            <Form.Select
              value={entityType}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                setEntityType(e.target.value);
                if (e.target.value === "3") {
                  setEntityId("");
                }
              }}
              required
            >
              <option value="1">Pracownik</option>
              <option value="2">Urządzenie</option>
              <option value="3">Przekierowanie dla stali</option>
            </Form.Select>
          </Form.Group>

          {entityType !== "3" && (
            <Form.Group className="mb-3">
              <Form.Label>Entity ID</Form.Label>
              <Form.Control
                type="number"
                value={entityId}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEntityId(e.target.value)}
                required
              />
            </Form.Group>
          )}

          {entityType === "3" && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Gatunek stali</Form.Label>
                <Form.Select
                  value={grade}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setGrade(e.target.value)}
                  required
                >
                  <option value="">Wybierz gatunek stali</option>
                  {Array.from(new Set(steelItems.map((item) => item.grade))).map((grade) => (
                    <option key={grade} value={grade}>
                      {grade}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Grubość (mm)</Form.Label>
                <Form.Select
                  value={thickness}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setThickness(e.target.value)}
                  required
                >
                  <option value="">Wybierz grubość</option>
                  {Array.from(new Set(steelItems.map((item) => item.thickness)))
                    .sort((a, b) => a - b)
                    .map((thickness) => (
                      <option key={thickness} value={thickness}>
                        {thickness}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditQrForm;
